import './App.css';
import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useNavigate } from 'react-router-dom';
import { Analytics } from "@vercel/analytics/react";
import { SpeedInsights } from '@vercel/speed-insights/react';
import Sidenav from './components/SideNavbar/SideNavbar';
import AboveAll from './components/AboveAll/AboveAll';
import Cars from './Pages/Cars';
import Drivers from './Pages/Drivers';
import Companies from './Pages/Companies';
import Login from './Pages/LoginPage/LoginPage';
import Trips from './Pages/Trips';
import Labels from './Pages/Labels';
import TripTypes from './Pages/TripTypes';
import Taxes from './Pages/Taxes';
import NewCar from './Pages/NewCar/NewCar';
import BillingItems from './Pages/BillingItems';
import TripDetails from './Pages/TripDetails/TripDetails';
import ContractForm from './Pages/ContractForm/ContractForm';
import DraftInvoice from './Pages/DraftInvoice/DraftInvoice';
import FinalInvoice from './Pages/FinalInvoice/FinalInvoice';
import Invoices from './Pages/Invoice';
import Fuels from './Pages/Fuel/Fuel';
import Expenditures from './Pages/Expenditure/Expenditure';
import VendorInfo from './components/VendorInfo/VendorInfo';
import PettyCash from './Pages/PettyCash';
import DriverPayroll from './Pages/DriverPayroll/DriverPayroll';
import Attendance from './Pages/DriverPayroll/Attendance';
import EditDriver from './components/DriverComponents/Editdriver';
import AddDriver from './components/DriverComponents/AddDriver';
import AddCompany from './components/CompanyComponents/AddCompany';
import {useAuth} from './components/AuthProvider';
import { setLogoutFunction } from "./utils/AuthHelper";
import FuelAnalysis from './Pages/FuelAnalysis/FuelAnalysis';
import Garages from './Pages/Garages';
import FuelStations from './Pages/FuelStations/FuelStations';
import EditCar from './components/CarComponents/EditCar';

const ProtectedRoutes = ({ children }) => {  
  const navigate = useNavigate();
  const isAuthenticated = !!localStorage.getItem("authToken");  

  useEffect(() => {
    if (!isAuthenticated) {
      navigate('/', { state: { error: 'Please login to continue.' } });  
    }
  }, [isAuthenticated, navigate]);  

  return isAuthenticated ? children : null;
};

function App() {
  const { logout } = useAuth();
  setLogoutFunction(logout);
  return (
    <div style={{ height: "100vh", width: "100vw", overflow: "hidden" }}>
      <Router>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/login/*" element={
            <ProtectedRoutes>
              <div className="app">
                <AboveAll />
                <Sidenav />
                <div className="main-content">
                    <Routes>
                        {/* All Protected Routes */}
                        <Route path="home/*" element={<VendorInfo />} />
                        <Route path="trips/*" element={<Trips />} />
                        <Route path="cars/*" element={<Cars />} />
                        <Route path="drivers/*" element={<Drivers />} />
                        <Route path="new_driver/*" element={<AddDriver />} />
                        <Route path="companies/*" element={<Companies />} />
                        <Route path="labels/*" element={<Labels />} />
                        <Route path="billing_items/*" element={<BillingItems />} />
                        <Route path="trip_types/*" element={<TripTypes />} />
                        <Route path="taxes/*" element={<Taxes />} />
                        <Route path="new_car/*" element={<NewCar />} />
                        <Route path="new_company/*" element={<AddCompany />} />
                        <Route path="trips/booking-details/:rowId" element={<TripDetails />} />
                        <Route path="contract_form/:rowId" element={<ContractForm />} />
                        <Route path="draft_invoice/*" element={<DraftInvoice />} />
                        <Route path="final-invoice/*" element={<FinalInvoice />} />
                        <Route path="invoices/*" element={<Invoices />} />
                        <Route path="fuels/*" element={<Fuels />} />
                        <Route path="expenditures/*" element={<Expenditures />} />
                        <Route path="pettycash/*" element={<PettyCash />} />
                        <Route path="drivers/driver_payroll/:driverId" element={<DriverPayroll />} />
                        <Route path="drivers/attendance/:driverId" element={<Attendance />} />
                        <Route path="drivers/edit_driver/:driverId" element={<EditDriver />} />
                        <Route path="garages/*" element={<Garages />} />
                        <Route path="cars/fuel_analysis/*" element={<FuelAnalysis />} />
                        <Route path="fuels/fuel_stations/*" element={<FuelStations />} />
                        <Route path="cars/edit_car/:carId" element={<EditCar />} />
                    </Routes>
                </div>
              </div>
            </ProtectedRoutes>
          } />
        </Routes>
      </Router>
      <Analytics />
      <SpeedInsights />
    </div>
  );
}

export default App;
